import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IHomeState } from './home-state.store';
import * as _ from './home-types.store';
import {
  IHomeParameter,
  IHomeMemberStatisticListingViewModel,
  IHomeTicketStatisticListingViewModel,
  IHomeBlockStatisticListingViewModel,
  IHomeContractorStatisticListingViewModel,
  IHomeServiceBookStatisticViewModel
} from '../../models/home';
import { ActivityStatus } from '../../common/enums';
export const actions: ActionTree<IHomeState, IRootState> = {
  [_.HOME_GET_MEMBERS]: async ({ commit, state }, param: IHomeParameter) => {

    if (state.memberStatistic.activityStatus === ActivityStatus.Loading) return;

    commit(_.HOME_GET_LOADING, { key: 'memberStatistic', activityStatus: ActivityStatus.Loading })

    return await state.service.getStatisticData<IHomeMemberStatisticListingViewModel>('team-members', param)
      .then(res => {
        commit(_.HOME_GET_MEMBERS, res)
        return res;
      })
      .catch(err => {
        console.log(err)
        commit(_.HOME_GET_LOADING, { key: 'memberStatistic', activityStatus: ActivityStatus.LoadFailed })
        return err
      })
  },
  [_.HOME_GET_TICKETS]: async ({ commit, state }, param: IHomeParameter) => {

    if (state.ticketStatistic.activityStatus === ActivityStatus.Loading) return;

    commit(_.HOME_GET_LOADING, { key: 'ticketStatistic', activityStatus: ActivityStatus.Loading })
    return await state.service.getStatisticData<IHomeTicketStatisticListingViewModel>('tickets', param)
      .then(res => {
        commit(_.HOME_GET_TICKETS, res)
        return res;
      })
      .catch(err => {
        console.log(err)
        commit(_.HOME_GET_LOADING, { key: 'ticketStatistic', activityStatus: ActivityStatus.LoadFailed })
        return err
      })
  },
  [_.HOME_GET_BLOCK]: async ({ commit, state }, param: IHomeParameter) => {

    if (state.blockStatistic.activityStatus === ActivityStatus.Loading) return;

    commit(_.HOME_GET_LOADING, { key: 'blockStatistic', activityStatus: ActivityStatus.Loading })

    return await state.service.getStatisticData<IHomeBlockStatisticListingViewModel>('block', param)
      .then(res => {
        commit(_.HOME_GET_BLOCK, res)
        return res;
      })
      .catch(err => {
        console.log(err)
        commit(_.HOME_GET_LOADING, { key: 'blockStatistic', activityStatus: ActivityStatus.LoadFailed })
        return err
      })
  },
  [_.HOME_GET_TICKET_BY_CONTRACTOR]: async ({ commit, state }, param: IHomeParameter) => {

    if (state.contractorStatistic.activityStatus === ActivityStatus.Loading) return;

    commit(_.HOME_GET_LOADING, { key: 'contractorStatistic', activityStatus: ActivityStatus.Loading })

    return await state.service.getStatisticData<IHomeContractorStatisticListingViewModel>('contractor', param)
      .then(res => {
        commit(_.HOME_GET_TICKET_BY_CONTRACTOR, res)
        return res;
      })
      .catch(err => {
        console.log(err)
        commit(_.HOME_GET_LOADING, { key: 'contractorStatistic', activityStatus: ActivityStatus.LoadFailed })
        return err
      })
  },
  [_.HOME_GET_SERVICE_BOOK]: async ({ commit, state }, param: IHomeParameter) => {

    if (state.serviceBookStatistic.activityStatus === ActivityStatus.Loading) return;

    commit(_.HOME_GET_LOADING, { key: 'serviceBookStatistic', activityStatus: ActivityStatus.Loading })

    return await state.service.getStatisticData<IHomeContractorStatisticListingViewModel>('service-book', param)
      .then(res => {
        commit(_.HOME_GET_SERVICE_BOOK, res)
        return res;
      })
      .catch(err => {
        console.log(err)
        commit(_.HOME_GET_LOADING, { key: 'serviceBookStatistic', activityStatus: ActivityStatus.LoadFailed })
        return err
      })
  }
}


// WEBPACK FOOTER //
// ./src/store/home/home-actions.store.ts